const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SECRE_KEY = process.env.REACT_APP_ODOO_SECRET_KEY;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const FILE_SECRET = process.env.REACT_APP_FILE_SECURITY_KEY;
export const PAYLOAD_SECRET = process.env.REACT_APP_PAYLOAD_SECURITY_KEY;
export const API_MIDPOINT = process.env.REACT_APP_API_ENABLE_ENDPOINT;
export default BASE_URL;
